import ModalPopup from "./modal";

export default ModalPopup;
